import React, { useEffect } from 'react';
import './Notification.css';

function Notification({ message, onClose }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000); // Adjust the time (in milliseconds) for how long the notification should appear

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="notification">
      <div className="notification-icon">🔔</div> {/* Notification icon */}
      <div className="notification-message">{message}</div>
      <button className="notification-close" onClick={onClose}>✖</button> {/* Close button */}
    </div>
  );
}

export default Notification;

